import CustomButton from './CustomButton/CustomButton';

import De from '../../assets/svg/DE.svg';
import Es from '../../assets/svg/ES.svg';
import Gb from '../../assets/svg/GB.svg';
import JDFLogo from '../../assets/svg/Logo.svg';
import Pt from '../../assets/svg/PT.svg';
import {PORTUGAL_UNLEASH_KEY} from '../../utils/constant';
import Smartlook from '../../utils/smartlook';
import {sendScreenViewNR} from '../../utils/util';

import {Button} from '@deere/fuel-react';
import {useFlag} from '@unleash/proxy-client-react';
import React from 'react';
import './CountrySelection.css';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

const CountrySelection = () => {
  const {i18n, t} = useTranslation();
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = React.useState('');
  const isPortugalEnabled = useFlag(PORTUGAL_UNLEASH_KEY);
  const countryList = [
    {
      countryName: 'España',
      countryCode: 'es',
      buttonImage: <img src={Es} alt="Spain" />,
    },
    {
      countryName: 'United Kingdom',
      countryCode: 'gb',
      buttonImage: <img src={Gb} alt="UK" />,
    },
    {
      countryName: 'Deutschland',
      countryCode: 'de',
      buttonImage: <img src={De} alt="Germany" />,
    },
    ...(isPortugalEnabled
      ? [
          {
            countryName: 'Portugal',
            countryCode: 'pt',
            buttonImage: <img src={Pt} alt="Portugal" />,
          },
        ]
      : []),
  ];

  React.useEffect(() => {
    sendScreenViewNR('countrySelection');
    Smartlook.navigation('countrySelection');
  }, []);

  const handleSubmit = (country) => {
    setSelectedCountry(country);
    i18n.changeLanguage(country);
  };

  const handleCountrySubmit = () => {
    localStorage.setItem('countryCode', selectedCountry);
    navigate('/');
  };

  return (
    <div className="CountrySelectionWrapper SecurityVerificationWrapper">
      <div className="SecurityVerificationContent">
        <div className="SecurityVerificationHeading">
          <div className="jdf-logo">
            <img src={JDFLogo} alt="JDF Logo" />
          </div>
        </div>
        <div className="countrySelectionWrapper SecurityVerificationContainer">
          <div className="titleText">
            <div className="titleHeading">
              {t('SEC_VERIFICATION_COUNTRY_HEADING')}
            </div>
            <div className="titleSubHeading">
              {t('SEC_VERIFICATION_COUNTRY_SUBHEADING')}
            </div>
          </div>
          <div className="countryOptionsWrapper" data-testid="country-select">
            {countryList.map((country, index) => (
              <CustomButton
                id={country.countryName + index}
                text={country.countryName}
                imageSource={country.buttonImage}
                variant={'imageButton'}
                isSelected={country.countryCode === selectedCountry}
                onClick={() => handleSubmit(country.countryCode)}
                key={'country-code' + country.countryCode}
              />
            ))}
          </div>
          <Button
            type="button"
            onClick={handleCountrySubmit}
            variant="primary"
            id="continueButton"
            disabled={!selectedCountry}
          >
            {t('CONTINUE')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CountrySelection;
